<template>
  <div>
    <keep-alive v-if="true">
      <img :src="imgUrl" style="width: 100%;">
    </keep-alive>  
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: ""
    };
  },
  watch: {
    //监听路由是否变化
    '$route' (to, from) { 
      if(to.query.pID != from.query.pID){
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.$http.get("api/vue_config/product_img?pID="+this.$route.query.pID).then((response) => {
        this.imgUrl = response.data.data;
        console.log(this.imgUrl)
      });
    },
  },
  created(){
    this.init();
  }
}
</script>

<style lang="less" scoped>

</style>
